<template>
  <div class="wl-results" v-if="doc">
    <results-summary :id="doc.id"></results-summary>
  </div>
</template>

<script>
import {
  ResultsSummary,
} from "@/components/results/swot";
export default {
  name: "ResultSwot",
  props: {
    doc: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
     
    };
  },
  components: {
    ResultsSummary
  },
};
</script>
